import { render, staticRenderFns } from "./PercentageCutDashboard.vue?vue&type=template&id=b5af235c&scoped=true&"
import script from "./PercentageCutDashboard.vue?vue&type=script&lang=js&"
export * from "./PercentageCutDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PercentageCutDashboard.vue?vue&type=style&index=0&id=b5af235c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5af235c",
  null
  
)

export default component.exports